import { render, staticRenderFns } from "./Bad.vue?vue&type=template&id=45a8b35e&scoped=true&"
import script from "./Bad.vue?vue&type=script&lang=js&"
export * from "./Bad.vue?vue&type=script&lang=js&"
import style0 from "./Bad.vue?vue&type=style&index=0&id=45a8b35e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8b35e",
  null
  
)

export default component.exports